"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-1b1f27c8"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "hide-sm" }, "取込", -1 /* HOISTED */));
const ImportIcon_vue_1 = __importDefault(require("../icons/ImportIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ImportButton',
    emits: ["open-import-modal"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        function handleImportBtnClick() {
            emit("open-import-modal");
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                class: "oplus-btn oplus-create-btn section-btn p-0 font-sm",
                onClick: handleImportBtnClick
            }, [
                (0, vue_2.createVNode)(ImportIcon_vue_1.default, { class: "rotate-icon" }),
                _hoisted_1
            ]));
        };
    }
});
